import React from 'react';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import * as S from './styles';

type OwnProps = {
  className?: string;
  countryCode: string;
  altText?: string;
  title?: string;
  showTitleAsTooltip?: boolean;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

const SIZE = 16;

export const CountryFlag: React.FC<OwnProps> = ({
  className,
  countryCode,
  altText,
  title,
  showTitleAsTooltip = true,
  tooltipPlacement = 'left',
}: OwnProps) => {
  const renderImage = () => {
    return (
      <S.Image
        title={altText}
        alt={altText}
        size={SIZE}
        src={`https://cdn.pji.nu/g/rfe/icons/flags/svg/${countryCode}.svg`}
      />
    );
  };

  return (
    <>
      {showTitleAsTooltip ? (
        <Tooltip
          placement={tooltipPlacement as TooltipPlacement}
          title={title}
          className={className}
          renderOnMouseOver
        >
          <S.CountryFlag>{renderImage()}</S.CountryFlag>
        </Tooltip>
      ) : (
        <S.CountryFlag className={className}>{renderImage()}</S.CountryFlag>
      )}
    </>
  );
};
